import React, { useState, useRef, useEffect } from 'react'
import { Tooltip, message, } from 'antd'
import FeedbackModal from 'view/components/feedbackModal'
import InfoModal from 'view/components/feedbackModal/infoModal'
import request from 'meinian-package/src/utils/request'
import { ELE_TYPE } from 'common/config/enum'
import Screen from './screen'
import './index.less'

function ColorTipTitle({ value, }) {
  const { tag, colorNumber, color, enName } = value
  const [info, setInfo] = useState(null)
  useEffect(() => {
    request.get(`/zhikuan/color/trend/trend-info?colorName=${tag}`).then((_info) => {
      setInfo(_info)
    })
  }, [])
  return (
    <div className="color-tip" style={{ position: 'relative' }}>
      <span style={{ position: 'absolute', height: 2, left: -6, right: -6, top: -6, backgroundColor: value.color }} />
      <span>{tag}</span>
      <span className="mini">{enName}</span>
      <span className="mini">{colorNumber}</span>
      <span className="mini">{color}</span>
      <div style={{ paddingTop: 10, marginTop: 10, borderTop: '1px solid #F4F4F4' }}>
        <a className="" onClick={() => { window.open(`/df/detail/design?name=${value.tag}&root=色系`) }}>更多款式&gt;</a>
        {!!info?.season && <a
          className=""
          onClick={() => {
            window.open(`/df/trend-summary/color-analysis/overview?season=${encodeURIComponent(info.season)}&gender=${info.gender}&color=${tag}`)
          }}
        >{info.season}&nbsp;{info.gender}热门颜色&gt;</a>}
      </div>
    </div>
  )
}
const DisplayText = ({ icon, name, value = [], clickable, root, hiddenTip = true, index }) => {
  const [firstTip, setTip] = useState(true)
  const $item = useRef()
  return (
    <li className="element-item" style={{ justifyContent: 'normal' }}>
      {icon}
      <span className="item-key">{name}</span>
      <Tooltip
        overlayClassName="fast-collect-tooltip"
        autoAdjustOverflow
        placement="bottomRight"
        title={<div onClick={e => e.stopPropagation()} className="df-card-detail-tip-wrapper">
          <div>点击设计要素，<br />可查看更多的相关款式</div>
          <div className="button" onClick={() => setTip(false)}>关闭</div>
        </div>}
        visible={firstTip && !hiddenTip && index === 0}
        getPopupContainer={() => $item.current}
      >
        <span ref={$item} className="item-value-wrapper">
          {value.length ? value.map(m => m.split(',').map(n => <span
            className="item-value"
            onClick={() => {
              if (!clickable) { message.error('抱歉，暂不支持查看。'); return }
              request.track({ code: 9200003, name: '知款-图片详情-设计要素跳转', params: { name: n, root } })
              window.open(`/df/detail/design?name=${n}&root=${root}`)
            }}
          >{n}</span>)) : null}
        </span>
      </Tooltip>
    </li>)
}

export const getElement = (curBoxLabelRetList) => {
  const elements = curBoxLabelRetList || {}
  const {
    colorList = [],
    style,
    texture,
    technology,
    rootFabric,
    fabric,
    accessories,
    contour,
    collar,
    vamp,
    element,
    process,
    sole,
    //
    shoeDecoration,
    shoeFabric,
    shoeTechnology,
    heelHeight,
    heelType,
    upper,
    toe,
    shoelace,
    shoes,
    tube,
  } = elements
  const finalElements = {
    texture,
    technology,
    fabric,
    accessories,
    contour,
    collar,
    vamp,
    element,
    process,
    sole,
    //
    shoeDecoration,
    shoeFabric,
    shoeTechnology,
    heelHeight,
    heelType,
    upper,
    toe,
    shoelace,
    shoes,
    tube,
  }
  const hasElements = texture
  || technology
  || rootFabric
  || fabric
  || accessories
  || vamp
  || element
  || process
  || sole
  //
  || shoeDecoration
  || shoeFabric
  || shoeTechnology
  || heelHeight
  || heelType
  || upper
  || toe
  || shoelace
  || shoes
  || tube

  // 存在一个则为鞋类 禁止跳转
  const clickable = !(shoeDecoration
      || shoeFabric
      || shoeTechnology
      || heelHeight
      || heelType
      || upper
      || toe
      || shoelace
      || shoes
      || tube)

  const show = (colorList || []).length || style || hasElements
  return {
    show,
    finalElements,
    clickable,
    colorList,
    style
  }
}

export const NewElement = ({
  currentImage,
  boxIndex,
  wrapperStyle = null,
  setBoxIndex,
  hiddenTip = false,
  feedbackModalVisible,
  setFeedbackModalVisible,
}) => {
  const elements = currentImage?.boxLabelRetList ? currentImage?.boxLabelRetList?.[boxIndex] || {} : {}
  const { show, finalElements, clickable, colorList, style } = getElement(elements)

  useEffect(() => {
    scrollTo()
  }, [boxIndex])

  const scrollTo = () => {
    const cardDom = document.getElementById(`box${boxIndex}`)
    cardDom && cardDom.scrollIntoView({ block: 'end', inline: 'center' })
  }

  const [infoModalVisible, setInfoModalVisible] = useState(false)
  const infoModalRef = useRef(null)

  const onFeedbackModalOk = async (params) => {
    request.post('/zhikuan/intelligence-tag/feedback', params).then(success => {
      if (success) {
        setFeedbackModalVisible(false)
        setInfoModalVisible(true)
        setTimeout(() => {
          infoModalRef.current?.onOk()
        })
        return true
      }
    })
    return false
  }

  if (!show) return <div className="meinian-image-detail-elements none" />
  return <div className="module">
    <div className="meinian-detail-image-detail-elements" style={wrapperStyle}>
      <Screen
        boxLabelRetList={currentImage.boxLabelRetList}
        currentImage={currentImage}
        boxIndex={boxIndex}
        setBoxIndex={setBoxIndex}
      />
      <ul>
        {(colorList && colorList.length) ? <li className="element-item">
          <span className="item-key">{ELE_TYPE.colorList}</span>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'row-reverse', }}>
            {colorList.map((value, index) => <Tooltip
              overlayClassName="color-tooltip"
              placement="topRight"
              arrowPointAtCenter
              title={<ColorTipTitle value={value} />}
            >
              <div
                key={`ele${index}`}
                className="item-value-color"
                style={{ backgroundColor: value.color }}
                onClick={() => {
                  request.track({ code: 9200003, name: '知款-图片详情-设计要素跳转', params: { name: value.tag, root: ELE_TYPE.colorList } })
                  window.open(`/df/detail/design?name=${value.tag}&root=色系`)
                }}
              />
            </Tooltip>)}
          </div>
        </li> : null}
        {style ? <DisplayText
          name={ELE_TYPE.style}
          value={style.map(n => n.tag)}
          clickable={clickable}
          root={ELE_TYPE.style}
        /> : null}
        {
          Object.keys(finalElements).filter(m => finalElements[m]).map((ele, eleIndex) => {
            if (ele === 'technology' || ele === 'accessories' || ele === 'sole') {
              return finalElements[ele].map(e => <DisplayText
                name={e.rootTag}
                value={[e.tag]}
                clickable={clickable}
                root={ELE_TYPE[ele]}
                hiddenTip={hiddenTip}
                index={eleIndex}
              />)
            }
            return <DisplayText
              name={ELE_TYPE[ele]}
              value={finalElements[ele].map(n => n.tag)}
              clickable={clickable}
              root={ELE_TYPE[ele]}
              hiddenTip={hiddenTip}
              index={eleIndex}
            />
          })
        }
      </ul>
    </div>
    {feedbackModalVisible && <FeedbackModal
      visible={feedbackModalVisible}
      picUrl={currentImage?.mainUrl}
      unionId={currentImage?.unionId}
      boxLabelRetList={currentImage.boxLabelRetList}
      onOk={onFeedbackModalOk}
      onClose={() => { setFeedbackModalVisible(false) }}
    />}
    {
      infoModalVisible && <InfoModal
        ref={infoModalRef}
        visible={infoModalVisible}
        onClose={() => {
          setInfoModalVisible(false)
        }}
      />
    }
  </div>
}
